import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { derivatAutoCreateVirtel_kadica, derivatAutoCreateVirtel_kadica_priprema_ulaza, derivatPoluproizvod_kadica_naziv } from "./ter-derivat-lib-terkk-kadica";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*

expt$sketch - experimental sketch
- expt je skraćenica od "experimet".


*/


export const draftel_codecs_pack_expt$sketch = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_expt$sketch.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'expt$sketch',
    // terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    // _protobomp: protobomp_manipulator.init(),
    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("expt$sketch", { allow_root_btns: true }), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

  };
  return preset_state;
};


draftel_codecs_pack_expt$sketch.default_pods_input_state = () => {
  /*
  return {
    msirinaunutrasnja: null,
    vrstaprofila: null,
    siframodula: null,
  };
  */
  return default_pods_input_state_smart_get('expt$sketch');
};


// 
draftel_codecs_pack_expt$sketch.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "msirinaunutrasnja",
  // "vrstaprofila",
  // "siframodula",
  ...Object.keys(draftel_codecs_pack_expt$sketch.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_expt$sketch.default_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------




// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------



